import { StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { colors } from './colors';

/** Primary action button for modals (dark green). */
export const primaryButtonStyle: ViewStyle = {
  backgroundColor: colors.button.primary,
  paddingVertical: 12,
  paddingHorizontal: 20,
  borderRadius: 8,
  alignItems: 'center',
  justifyContent: 'center',
};

export const primaryButtonTextStyle: TextStyle = {
  color: colors.button.primaryText,
  fontSize: 16,
  fontWeight: '600',
};

export const modalFooterButtonStyles = StyleSheet.create({
  primary: {
    backgroundColor: colors.button.primary,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  primaryText: {
    color: colors.button.primaryText,
    fontSize: 16,
    fontWeight: '600',
  },
});
